import React from 'react';
import type OAuthCredentialsAdminType from '@atlassian/jira-spa-apps-admin-oauth-credentials/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyOAuthCredentialsAdmin = lazyForPaint<typeof OAuthCredentialsAdminType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-oauth-credentials", jiraSpaEntry: "async-admin-oauth-credentials" */ '@atlassian/jira-spa-apps-admin-oauth-credentials'
		),
	),
);

const AsyncOAuthCredentialsAdmin = (): React.JSX.Element => (
	<LazyPage Page={LazyOAuthCredentialsAdmin} pageId="admin-oauth-credentials" shouldShowSpinner />
);

export default AsyncOAuthCredentialsAdmin;
